module.exports = __webpack_public_path__ + "img/icons.a855486f.svg";